import React, { createContext, useCallback, useContext, useState } from 'react';

import { IBaseProps } from '@rbi-ctg/frontend';
import { ICartEntry } from '@rbi-ctg/menu';

export interface IMenuUIContext {
  activeCartEntries: ICartEntry[];
  setActiveCartEntries: (cartEntries: ICartEntry[]) => void;
}

export const MenuUIContext = createContext<IMenuUIContext>({} as IMenuUIContext);
export const useMenuUIContext = () => useContext(MenuUIContext);

export const MenuUi = MenuUIContext.Consumer;

export const MenuUIProvider = ({ children }: IBaseProps) => {
  const [activeCartEntries, setActiveCartEntriesInternal] = useState<ICartEntry[]>([]);

  const setActiveCartEntries = useCallback((entries: React.SetStateAction<ICartEntry[]>) => {
    setActiveCartEntriesInternal(entries);
  }, []);

  return (
    <MenuUIContext.Provider
      value={{
        activeCartEntries,
        setActiveCartEntries,
      }}
    >
      {children}
    </MenuUIContext.Provider>
  );
};
